import basics from "./basics";
import charts from "./charts";
import formatting from "./formatting";
import fx from "./fx";
import grid from "./grid";
import imageTour from "./images";
import intro from "./intro";
import links from "./links";
import publishing from "./publishing";
import split from "./split";
import stories from "./stories";

const stepSizes = () => {
    return {
        intro: intro.length,
        basics: basics(" ").length,
        stories: stories(" ").length,
        formatting: formatting.length,
        links: links.length,
        images: imageTour.length,
        charts: charts.length,
        publishing: publishing.length,
        split: split.length,
        grid: grid.length,
        fx: fx.length,
    };
};

export default stepSizes;
